<div class="fixed inset-0 bg-black bg-opacity-50  flex items-center justify-center z-[100] transition-colors duration-200">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col m-4 transition-colors duration-200">
      <!-- Header -->
      <div class="flex justify-between items-center px-6 py-4 border-b border-gray-200 ">
        <div class="flex flex-col">
          <h2 class="text-xl font-semibold text-gray-800  transition-colors duration-200">Subir comprobantes PDF</h2>
          <span class="text-red-500 text-sm">*IMPORTANTE: Los comprobantes importados y procesados quedan pendientes de ser aprobados por la empresa.</span>
        </div>
        <button 
          class="text-gray-400  hover:text-gray-600  text-2xl w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100  transition-colors duration-200"
          (click)="cerrarModal()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>        
        </button>
      </div>
  
      <!-- Contenido -->
      <div class="flex-1 overflow-y-auto px-6 py-4">
        <!-- <h4 class="text-lg font-medium text-gray-900  mb-2 transition-colors duration-200">
          CENCO
        </h4> -->
        <!-- Carga de CENCO Masivo -->
        <!-- <div *ngIf="habilitarCencoMasivo" class="mb-2">
          <app-autocomplete-con-filtros *ngIf="selectOptionsCencos.length > 0" [options]="selectOptionsCencos"
            [(value)]="cencoSeleccionado" (valueChange)="onCencoChange($event)"
            [placeholder]="'Seleccionar CENCO'" [clearable]="true">
          </app-autocomplete-con-filtros>
        </div> -->
        <!-- Modo de carga -->    
        <h3 *ngIf="habilitarModoCarga" class="text-lg font-medium text-gray-900  mb-2 transition-colors duration-200">
          Modo de carga
        </h3>
          <div *ngIf="habilitarModoCarga" class="flex space-x-4 mb-4">
            <label
              class="flex items-start p-3 border-2 rounded-lg cursor-pointer transition-colors duration-200"
              [ngClass]="{
                'border-rp-orange bg-orange-50 ': modoCarga === 'conceptos',
                'border-gray-200  hover:border-gray-300': modoCarga !== 'conceptos'
              }">
              <input type="radio" name="modoCarga" [(ngModel)]="modoCarga" value="conceptos" 
                class="w-4 h-4 mt-1 text-rp-orange border-gray-300 ">
              <div class="ml-4 flex-grow">
                <span class="font-medium text-gray-800  transition-colors duration-200">Conceptos</span>
                <p class="text-xs text-gray-600 transition-colors duration-200">
                  Ideal para servicios, honorarios y gastos generales. Permite cargar conceptos con importes y cuentas contables.
                </p>
              </div>
            </label>
    
            <label
              class="flex items-start p-3 border-2 rounded-lg cursor-pointer transition-colors duration-200"
              [ngClass]="{
                'border-rp-orange bg-orange-50 ': modoCarga === 'articulos',
                'border-gray-200  hover:border-gray-300 ': modoCarga !== 'articulos'
              }">
              <input type="radio" name="modoCarga" [(ngModel)]="modoCarga" value="articulos" 
                class="w-4 h-4 mt-1 text-rp-orange border-gray-300 ">
              <div class="ml-4 flex-grow">
                <span class="font-medium text-gray-800  transition-colors duration-200">Artículos</span>
                <p class="text-xs text-gray-600  transition-colors duration-200">
                  Ideal para productos físicos. Permite cargar artículos con cantidad, precio unitario y códigos de producto.
                </p>
              </div>
            </label>
          </div>
        <!-- Información del límite de archivos -->
        <div *ngIf="archivos.length > 0" class="mb-4 p-3 bg-blue-50  border border-blue-200  rounded-lg">
          <div class="flex items-center">
            <svg class="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
            </svg>
            <span class="text-sm text-blue-700 ">
              <strong>{{ archivos.length }}</strong> de <strong>{{ cantMaximaArchivos }}</strong> archivos seleccionados
              <span *ngIf="archivosDisponibles > 0">({{ archivosDisponibles }} disponibles)</span>
              <span *ngIf="limiteArchivosAlcanzado" class="text-orange-600 ">- Límite alcanzado</span>
            </span>
          </div>
        </div>
  
        <!-- Zona de drop -->
        <div 
          class="border-2 border-dashed rounded-lg p-8 text-center transition-colors duration-200"
          [class.border-rp-orange]="isDragOver && !limiteArchivosAlcanzado"
          [class.bg-orange-50]="isDragOver && !limiteArchivosAlcanzado"
          [class]="isDragOver && !limiteArchivosAlcanzado ? '' : ''"
          [class.border-gray-300]="!isDragOver && !limiteArchivosAlcanzado"
          [class]="!isDragOver && !limiteArchivosAlcanzado ? '' : ''"
          [class.bg-gray-50]="!isDragOver && !limiteArchivosAlcanzado"
          [class]="!isDragOver && !limiteArchivosAlcanzado ? '' : ''"
          [class.border-gray-400]="limiteArchivosAlcanzado"
          [class.bg-gray-100]="limiteArchivosAlcanzado"
          [class]="limiteArchivosAlcanzado ? '' : ''"
          [class.opacity-50]="limiteArchivosAlcanzado"
          (dragover)="!limiteArchivosAlcanzado && onDragOver($event)"
          (dragleave)="!limiteArchivosAlcanzado && onDragLeave($event)"
          (drop)="!limiteArchivosAlcanzado && onDrop($event)">
          
          <div class="mb-4">
            <h3 class="text-lg font-medium mb-2 transition-colors duration-200"
                [class.text-gray-900]="!limiteArchivosAlcanzado"
                [class.text-gray-500]="limiteArchivosAlcanzado">
              <span *ngIf="!limiteArchivosAlcanzado">Arrastra tus archivos PDF aquí</span>
              <span *ngIf="limiteArchivosAlcanzado">Límite de archivos alcanzado</span>
            </h3>
            <p class="text-sm mb-4 transition-colors duration-200"
               [class.text-gray-600]="!limiteArchivosAlcanzado"
               [class.text-gray-500]="limiteArchivosAlcanzado">
              <span *ngIf="!limiteArchivosAlcanzado">o haz clic para seleccionar archivos</span>
              <span *ngIf="limiteArchivosAlcanzado">Elimine algunos archivos para agregar nuevos</span>
            </p>
            <button 
              class="px-6 py-2 rounded-md font-medium transition-colors duration-200"
              [class.bg-rp-orange]="!limiteArchivosAlcanzado"
              [class.text-white]="!limiteArchivosAlcanzado"
              [class.bg-gray-300]="limiteArchivosAlcanzado"
              [class.text-gray-500]="limiteArchivosAlcanzado"
              [class.cursor-not-allowed]="limiteArchivosAlcanzado"
              [disabled]="limiteArchivosAlcanzado"
              (click)="!limiteArchivosAlcanzado && fileInput.click()">
              <span *ngIf="!limiteArchivosAlcanzado">Seleccionar Archivos</span>
              <span *ngIf="limiteArchivosAlcanzado">Límite Alcanzado</span>
            </button>
          </div>
          
          <input 
            #fileInput
            type="file" 
            multiple 
            accept=".pdf"
            (change)="onFileSelected($event)"
            [disabled]="limiteArchivosAlcanzado"
            class="hidden">
        </div>
  
        <!-- Lista de archivos -->
        <div *ngIf="archivos.length > 0" class="mt-6 space-y-3">
          <div class="flex justify-between items-start">
            <h4 class="text-md font-medium text-gray-900  mb-3 transition-colors duration-200">
              Archivos seleccionados ({{ archivos.length }})
            </h4>


            <button 
            *ngIf="tieneArchivosConErrorSinEnviar"
            (click)="enviarArchivosConError()"
            [disabled]="procesandoArchivos"
            class="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs 
                  bg-orange-50 text-orange-600 hover:bg-orange-100 border border-orange-300 transition-all">
              Enviar por mail archivos con error
            </button>
          </div>
          
          <div *ngFor="let archivo of archivos; let i = index" 
               class="flex items-center justify-between bg-gray-50  p-4 rounded-lg transition-colors duration-200">
            <div class="flex items-center gap-3">
              <span class="text-2xl">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                </svg>
              </span>
              <div>
                <div class="font-medium text-gray-900  text-sm transition-colors duration-200">{{ archivo.file.name }}</div>
                <div class="text-xs text-gray-500  transition-colors duration-200">{{ formatearTamano(archivo.file.size) }}</div>
              </div>
            </div>
            
            <div class="flex items-center gap-2">
              <!-- Estado del procesamiento -->
              <div class="flex items-center gap-2">
                <div *ngIf="archivo.procesando" class="flex items-center gap-2">
                  <div class="w-4 h-4 border-2 border-rp-orange border-t-transparent rounded-full animate-spin"></div>
                  <span class="text-xs text-gray-600  transition-colors duration-200">Procesando...</span>
                </div>
                
                <div *ngIf="archivo.completado" class="flex items-center gap-2">
                  <span class="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                  <span class="text-xs text-green-600  transition-colors duration-200">Completado</span>
                </div>

                <div class="flex flex-col items-center gap-2">
                
                <div *ngIf="archivo.error" class="flex items-center gap-2">
                  <span class="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white text-xs">✗</span>
                  <span class="text-xs text-red-600  transition-colors duration-200">Error</span>
                  <button 
                    *ngIf="archivo.errorMessage"
                    class="text-xs text-red-500 hover:text-red-700 underline"
                    (click)="alertService.showErrorToast(archivo.errorMessage!, 'Error en ' + archivo.file.name)">
                    Ver detalles
                  </button>
                </div>

                <span 
                  *ngIf="archivo.emailEnviado"
                  class="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs 
                        bg-green-50 text-green-600 hover:bg-green-100 
                        border border-green-300 transition-all">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                  </svg>
                  Enviado por mail
                </span>
              </div>
              
              <button 
                class="text-gray-400  hover:text-red-500  text-lg w-6 h-6 flex items-center justify-center rounded hover:bg-red-50  transition-colors duration-200"
                (click)="eliminarArchivo(i)"
                [disabled]="procesandoArchivos">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                  </svg>
              </button>
            </div>
          </div>
        </div>
  
        <!-- Progreso general -->
        <div *ngIf="procesandoArchivos" class="mt-6">
          <div class="bg-gray-200  rounded-full h-2 overflow-hidden transition-colors duration-200">
            <div 
              class="bg-rp-orange h-2 rounded-full transition-all duration-300"
              [style.width.%]="progreso">
            </div>
          </div>
          <div class="text-center mt-2 text-sm text-gray-600  transition-colors duration-200">
            Procesando {{ archivosCompletados }} de {{ archivos.length }} archivos...
          </div>
        </div>
      </div>
  
      <!-- Footer -->
      <div class="flex justify-between items-center p-6 border-t border-gray-200  bg-gray-50  transition-colors duration-200">
        <div class="text-sm text-gray-600  transition-colors duration-200">
          <span *ngIf="archivos.length > 0">
            {{ archivos.length }} archivo(s) seleccionado(s)
            <span *ngIf="archivosCompletados > 0" class="text-green-600  ml-2 transition-colors duration-200">
              ✓ {{ archivosCompletados }} completado(s)
            </span>
            <span *ngIf="archivosConError > 0" class="text-red-600  ml-2 transition-colors duration-200">
              ✗ {{ archivosConError }} con error(es)
            </span>
          </span>
          <span *ngIf="archivos.length === 0">No hay archivos seleccionados</span>
        </div>
        
        <div class="flex gap-3">
          <button 
            class="px-4 py-2 text-gray-700  border border-gray-300  rounded-md hover:bg-gray-5 transition-colors duration-200"
            (click)="cerrarModal()"
            [disabled]="procesandoArchivos">
            Cancelar
          </button>
                 
          <button 
            class="px-6 py-2 bg-rp-orange text-white rounded-md font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="procesarArchivos()"
            [disabled]="archivos.length === 0 || procesandoArchivos">
            <span *ngIf="!procesandoArchivos">Procesar Facturas</span>
            <span *ngIf="procesandoArchivos" class="flex items-center gap-2">
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Procesando...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div> 